// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"fbb5ea88","208":"f1913f33","209":"a27902f3","878":"6a0e6e27"}[chunkId] + ".chunk.js";
};